import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface Props {
  before: string;
  after: string;
}

export default function BeforeAfter({ before, after }: Props) {
  const [side, setSide] = useState<'after' | 'before'>('after');
  return (
    <div>
      <div className="flex gap-1 p-1 rounded-full border hairline w-fit font-mono text-[11px] mb-4">
        {(['before', 'after'] as const).map((s) => (
          <button
            key={s}
            onClick={() => setSide(s)}
            className={`px-3 py-1 rounded-full transition ${
              side === s ? 'bg-accent text-white' : 'text-ink-dim hover:text-ink'
            }`}
          >
            {s === 'before' ? 'Pre-2022' : 'May 2026'}
          </button>
        ))}
      </div>
      <AnimatePresence mode="wait">
        <motion.p
          key={side}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.18 }}
          className="text-ink-dim leading-relaxed"
        >
          {side === 'before' ? before : after}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
